{
  "select_plan": {
    "title": "Please select a plan",
    "free_trial": "Free for 14 days",
    "cancel_any_time": "Cancel any time",
    "expert_support": "Expert support included",
    "need_help": "Need help or have questions?",
    "contact_support": "Speak with our team"
  },
  "change_plan": {
    "title": "Change plan"
  },
  "errors": {
    "load_plans": "Unable to load billing plans. Please try again."
  }
}
